import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { useCreateMailpiecesListCommentMutation, useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';
import NotifyMairoomComment from './NotifyComment';
import useNotifyComment from './NotifyComment/useNotifyComment';

export const FinishRecycle = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces] = useUpdatePiecesMutation();
  const [createMailpiecesListComment] = useCreateMailpiecesListCommentMutation();

  const [actionInProgress, setActionInProgress] = useState<boolean>(false);

  const { values, changeValues } = useNotifyComment();

  const confirmAction = async () => {
    try {
      setActionInProgress(true);

      await updatePieces({
        pieces: mailpieces.map((piece) => ({ id: piece.id })),
        action: PieceAction.FinishRecycle,
        shouldNotifyRecipient: !values.skipNotifyRecipient,
      }).unwrap();

      const comment = values.comment.trim();

      if (comment.trim().length) {
        await createMailpiecesListComment({
          text: comment.trim(),
          notifyMailroom: values.notifyMailroom,
          pieceIds: mailpieces.map((piece) => piece.id),
        }).unwrap();
      }

      setActionInProgress(false);
      onActionFinish();
    } catch (error) {
      setActionInProgress(false);
    }
  };

  const content = (
    <Box>
      <Typography variant="body1" color="text.secondary">
        {mailpieces.length === 1 ? (
          "Please recycle this item, and click Complete when you're done."
        ) : (
          <>
            Please recycle <strong>{mailpieces.length}</strong> item(s), and click Complete when you&apos;re done.
          </>
        )}
      </Typography>

      <NotifyMairoomComment values={values} onChange={changeValues} />
    </Box>
  );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={actionInProgress}
      maxWidth="sm"
      title={mailpieces.length === 1 ? 'Recycle item' : 'Recycle selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Complete"
      cancelButtonTitle="Cancel"
    />
  );
};
